import { render, staticRenderFns } from "./AnswerColumn.vue?vue&type=template&id=e2314750&scoped=true&"
import script from "./AnswerColumn.vue?vue&type=script&lang=js&"
export * from "./AnswerColumn.vue?vue&type=script&lang=js&"
import style0 from "./AnswerColumn.vue?vue&type=style&index=0&id=e2314750&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2314750",
  null
  
)

export default component.exports